import React, { useCallback, useState } from 'react';
import { useSWRConfig } from 'swr';
import { Col, Row } from 'antd';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loading } from '../../atoms';
import { LoginForm } from '../../organisms/login/LoginForm';
import { LoginPayload, mutateLoginRepository } from '../../../repository/mytm/auth/loginRepository';
import { LoginBackground, LogoMyTM } from '../../../assets/index';
import { PAGES } from '../../../constants/urls/page-urls';
import { logging } from '../../../utils/log';
import { LOGIN_TRANSLATION } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';
import { SIDER_MENU } from '../../../constants/sider/sider-menu';

export const Login = () => {
  const { t } = useTranslation(LOGIN_TRANSLATION);
  const history = useHistory();
  const { mutate } = useSWRConfig();

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>();

  const onLogin = useCallback(
    async (values: LoginPayload) => {
      try {
        setIsLoading(true);
        const response = await mutateLoginRepository(mutate, values);
        const itemFirstRedirect = SIDER_MENU.find(
          item => item?.group && item.roles?.includes(response?.data?.role),
        )?.group?.find(x => x.roles?.includes(response?.data?.role));
        let redirectPage: string = PAGES?.HOME.FOLDER.THE_DAILY;
        if (itemFirstRedirect?.children) {
          const children = itemFirstRedirect?.children?.find(x => x.roles?.includes(response?.data?.role));
          redirectPage = children?.route || redirectPage;
        } else {
          redirectPage = itemFirstRedirect?.route || redirectPage;
        }
        history.push(redirectPage);
        setIsLoading(false);
        setIsError(false);
      } catch (error: any) {
        setIsLoading(false);
        setIsError(true);
        setErrorMessage(error.errorMessage);
        logging(error);
      }
    },
    [history],
  );

  return (
    <Loading isLoading={isLoading}>
      <Container>
        <div className="dark-overlay">
          <Col span={12} offset={12}>
            <Row>
              <StyledWrapperForm span={12} offset={3}>
                <img src={LogoMyTM} alt="avatar-TM" />
                <h1>{t('signIn')}</h1>
                {/* <span>{t('forget')}</span> */}
                <LoginForm onLogin={onLogin} isError={isError} errorMessage={errorMessage} />
              </StyledWrapperForm>
            </Row>
          </Col>
        </div>
      </Container>
    </Loading>
  );
};

const Container = styled(Row)`
  ${appStyles.fullWidthHeight}
  background-image: url(${LoginBackground});
  background-repeat: no-repeat;
  background-size: cover;

  & > .dark-overlay {
    position: relative;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.36);
    ${appStyles.fullWidthHeight}
  }
`;

const StyledWrapperForm = styled(Col)`
  min-height: 60vh;
  margin-top: 18vh;
  height: 64vh;
  background: #f3f2ef;
  padding: 5%;
  border-radius: 10px;

  & > img {
    margin-bottom: 3vh;
  }

  & > h1 {
    font-size: 28px;
    font-weight: bold;
    line-height: 0.5;
  }

  & > span {
    font-weight: bold;
    color: #1ec45f;
  }
`;
